/**
 * Línea "Tu turno hoy" dentro de la card "Tu jornada" del Inicio (008 · T096; contracts/ui.md
 * §2.1, research R-25). **No** es una card nueva: `JourneyCard` la recibe por su ranura `schedule`
 * y la pinta bajo el estado, así que el máximo de cards del viewport inicial (R-30 de la 006:
 * jornada, últimas marcaciones y, a lo sumo, regularización o instalación) no cambia.
 *
 * La lectura (`useStaffDays`) la lanza `HomeScreen` en paralelo a las demás: mientras carga, si
 * falla o sin red y sin datos, no se monta —el Inicio nunca espera ni se rompe por el horario—. Sin horario
 * para el trabajador (`has_schedule = false`) tampoco pinta nada (US6-6: sin textos vacíos).
 * Icono `calendar-clock` 20 px **y** texto 16 px.
 */
import { CalendarClock } from 'lucide-react';

import type { StaffDaysResponse } from '@fermin/contracts';

import { todayLineOf } from './format';


export interface TodayShiftLineProps {
  data: StaffDaysResponse;
}

/** Presentacional: recibe la respuesta y elige el texto (`todayLineOf`). */
export function TodayShiftLine({ data }: TodayShiftLineProps) {
  const line = todayLineOf(data);
  if (line === null) return null;
  return (
    <div
      data-testid="home-today-shift"
      data-kind={line.kind}
      className="flex items-start gap-fm-2 text-fm-base text-fm-text"
    >
      <CalendarClock
        aria-hidden="true"
        size={20}
        className="mt-0.5 shrink-0 text-fm-primary-compact"
      />
      <div className="flex flex-col gap-fm-1">
        {line.lines.map((text) => (
          <p key={text}>{text}</p>
        ))}
      </div>
    </div>
  );
}
